import { useEffect } from 'react';
import { useSession } from './session';
import { initAnalytics, setProfile, trackErrors } from './track';

/** Mounted once at the root: starts the client and follows who is signed in. */
export function Analytics() {
  const session = useSession();
  useEffect(() => {
    initAnalytics();
    trackErrors();
  }, []);
  const id = session.data?.user?.id ?? null;
  useEffect(() => {
    if (!session.isLoading) setProfile(id);
  }, [id, session.isLoading]);
  return null;
}
